import get from 'lodash/get';

export function getFeatureFlag (subscription, flag) {
    return !!get(subscription, `featureFlags.${flag}`, false);
}

export function subIsInTrial (subscription) {
    return get(subscription, 'isInTrial', false);
}

export function getTrialEndDate (subscription) {
    return get(subscription, 'trialEndDate', 0);
}

export function getSubPlan (subscription) {
    if (getFeatureFlag(subscription, 'pendoFree')) {
        return 'free';
    }
    if (getFeatureFlag(subscription, 'starterPackage')) {
        return 'starter';
    }
    if (getFeatureFlag(subscription, 'starter2024Package')) {
        return 'starter2024';
    }

    return 'engage';
}

export function subIsDefaultPlan (subscription) {
    return getSubPlan(subscription) === 'engage' && !subIsInTrial(subscription);
}

export function getTrialData (subscription) {
    const msPerDay = 24 * 60 * 60 * 1000;
    const currentTime = new Date();
    const trialEndDate = subscription?.trialEndDate ? new Date(subscription.trialEndDate) : 0;
    const msUntilTrialEnd = trialEndDate ? trialEndDate.getTime() - currentTime.getTime() : 0;
    const trialDaysLeft = msUntilTrialEnd / msPerDay;

    return {
        trialEndDate,
        trialEndDateISOString: trialEndDate ? trialEndDate.toISOString() : 0,
        trialDaysLeft,
        isInTrial: msUntilTrialEnd > 0,
    };
}
